var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(!_vm.loading)?_c('div',[_c('div',{staticClass:"avatar p-1",class:{ 'rounded-circle': _vm.rounded },style:({
        backgroundImage: 'url(' + _vm.apiURL + '/storage/' + _vm.img + ')',
        width: _vm.propSize,
        height: _vm.propSize,
      })})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }